import useSite from "@casino/legacy/client/hooks/useSite";
import { getCookie } from "@workspace/cookies/browser";
import useFetchUser from "./useFetchUser";

const useCurrentUser = () => {
  const user = useFetchUser();
  const { siteConfig } = useSite();
  const colorScheme = normalizeColorScheme(siteConfig);
  return { colorScheme, ...user };
};

const normalizeColorScheme = (siteConfig: SiteConfig): ColorScheme => {
  const cookieTheme = getCookie("theme") as ColorScheme | undefined;
  if (cookieTheme === undefined) {
    return siteConfig.defaultColorScheme;
  }
  return cookieTheme;
};

export default useCurrentUser;
